import { render, staticRenderFns } from "./WaitingListV2.vue?vue&type=template&id=2f14e8d8&scoped=true"
import script from "./WaitingListV2.vue?vue&type=script&lang=js"
export * from "./WaitingListV2.vue?vue&type=script&lang=js"
import style0 from "./WaitingListV2.vue?vue&type=style&index=0&id=2f14e8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14e8d8",
  null
  
)

export default component.exports